import { Gift } from "lucide-react";

// Buy 4, get the cheapest 5th free. Progress toward the next free meal.
export const RewardProgress = ({ totalQty = 0, freeCount = 0 }) => {
  const towardNext = totalQty % 5;
  const remaining = totalQty === 0 ? 5 : (5 - towardNext) % 5;
  const pct = (towardNext / 5) * 100;

  return (
    <div
      data-testid="reward-progress"
      className="bg-white rounded-3xl border-2 border-rose-100 p-5 shadow-[0_8px_25px_-8px_rgba(251,113,133,0.25)]"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2.5">
          <div className="h-10 w-10 rounded-2xl bg-rose-100 text-rose-500 flex items-center justify-center">
            <Gift size={20} />
          </div>
          <div>
            <p className="font-display font-bold text-slate-800 leading-tight">
              Buy 4, Get the 5th FREE
            </p>
            <p className="text-sm text-slate-500">
              {freeCount > 0 ? (
                <span className="text-emerald-600 font-semibold">
                  🎉 {freeCount} free meal{freeCount > 1 ? "s" : ""} unlocked!
                </span>
              ) : remaining === 0 ? (
                "Add meals to start earning"
              ) : (
                `Add ${remaining} more meal${remaining > 1 ? "s" : ""} to unlock a free one!`
              )}
            </p>
          </div>
        </div>
        <span className="font-display font-bold text-lg text-rose-500">{towardNext}/5</span>
      </div>

      <div className="h-4 rounded-full bg-slate-100 overflow-hidden p-0.5 border border-slate-200">
        <div
          className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-rose-400 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="flex justify-between mt-2 px-0.5">
        {[1, 2, 3, 4, 5].map((n) => (
          <span
            key={n}
            className={`text-xs font-bold ${
              n <= towardNext ? "text-emerald-500" : n === 5 ? "text-rose-400" : "text-slate-300"
            }`}
          >
            {n === 5 ? "FREE" : n}
          </span>
        ))}
      </div>
    </div>
  );
};
